// extracted by mini-css-extract-plugin
export default {"options":"ViewerMenu_options__OsKd5","options--open":"ViewerMenu_options--open__gDfTa"};